import type { TTripTaskRes, WarehouseRes } from 'api/swagger';
import { ETripTaskType } from 'types/trips';
import type {
  IDirectionData,
  IDirectionDataService,
  IMapPoint,
  ITripTaskDirectionDataServiceParams,
} from 'components/map/map-container/direction-data/types';

export class TripTaskDirectionDataService implements IDirectionDataService {
  constructor(protected readonly params: ITripTaskDirectionDataServiceParams) {}

  WAREHOUSE_BASED_TRIP_TASK_TYPES = [ETripTaskType.loading_wh, ETripTaskType.unloading_wh];

  public get data(): IDirectionData | null {
    if (this.params.tripTasks.length < 2) {
      return null;
    }

    return {
      origin: this.origin,
      destination: this.destination,
      waypoints: this.waypoints,
    };
  }

  private get firstTripTask(): TTripTaskRes {
    return this.params.tripTasks[0];
  }

  private get lastTripTask(): TTripTaskRes {
    return this.params.tripTasks[this.params.tripTasks.length - 1];
  }

  private get intermediateCargo(): TTripTaskRes[] {
    return this.params.tripTasks.slice(1, this.params.tripTasks.length - 1);
  }

  private get origin(): IMapPoint {
    return this.getMapPointFromTripTask(this.firstTripTask);
  }

  private get destination(): IMapPoint {
    return this.getMapPointFromTripTask(this.lastTripTask);
  }

  private get waypoints(): IMapPoint[] {
    return this.intermediateCargo.map((tripTask) => this.getMapPointFromTripTask(tripTask));
  }

  private getMapPointFromTripTask(tripTask: TTripTaskRes): IMapPoint {
    const isWarehouseBasedTripTask = this.WAREHOUSE_BASED_TRIP_TASK_TYPES.includes(tripTask.type as ETripTaskType);

    if (isWarehouseBasedTripTask) {
      const warehouse = tripTask.warehouse as WarehouseRes;
      return {
        lng: warehouse?.lng ?? 0,
        lat: warehouse?.lat ?? 0,
      };
    }

    return {
      lng: tripTask.address?.lng ?? 0,
      lat: tripTask.address?.lat ?? 0,
    };
  }
}
